import { App, Button, Input, Modal } from 'antd';
import { SessionInfo } from './components/session-info';
import { useTranslation } from 'translations/hooks';
import { useState } from 'react';
import { Link } from 'react-router';
import { Routes } from 'business/router/constants';
import { useGetScanCodeConfigData } from 'ui/user-menu/hooks/data/use-get-scan-code-config';

export const SessionInfoPage = () => {
  const { t } = useTranslation();

  const { message } = App.useApp();

  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [pin, setPin] = useState('');
  const [isModalVisible, setIsModalVisible] = useState(true);

  const { data: scanCodeConfigData } = useGetScanCodeConfigData(isModalVisible);

  const handlePinSubmit = () => {
    if (pin === scanCodeConfigData?.code) {
      setIsAuthenticated(true);
      setIsModalVisible(false);
      setPin('');
    } else {
      message.error(t('header.pinCode.error'));
      setPin('');
    }
  };

  return (
    <>
      {isAuthenticated ? (
        <SessionInfo />
      ) : (
        <div className="flex h-full w-full flex-col items-center justify-center">
          <p className="px-4">{t('common.waitingAuthorization')}</p>
          <Link to={Routes.App}>
            <Button type="primary">{t('common.redirectHome')}</Button>
          </Link>
        </div>
      )}
      <Modal
        title={t('header.pinCode.title')}
        open={isModalVisible}
        onOk={handlePinSubmit}
        onCancel={() => setIsModalVisible(false)}
        okText={t('common.validate')}
        cancelText={t('common.cancel')}
        cancelButtonProps={{ color: 'primary', variant: 'outlined' }}
        destroyOnHidden
        closable={false}
      >
        <Input.Password
          autoComplete="one-time-code"
          placeholder={t('common.placeholder.inputText')}
          value={pin}
          onChange={(e) => setPin(e.target.value)}
          onPressEnter={handlePinSubmit}
          maxLength={4}
          autoFocus
          className="text-base"
        />
      </Modal>
    </>
  );
};
